


































import { PatientExerciseTypes } from '@/jsonapi/PatientExercise'

type ComponentData = {
  showNewExerciseDialog: boolean
  exerciseTypes: { name: string; value: string }[]
  exerciseType: PatientExerciseTypes.Cardio | PatientExerciseTypes.Strength
}

export default {
  data(): ComponentData {
    return {
      showNewExerciseDialog: false,
      exerciseTypes: [
        { name: 'Strengthening', value: PatientExerciseTypes.Strength },
        { name: 'Aerobic', value: PatientExerciseTypes.Cardio },
      ],
      exerciseType: PatientExerciseTypes.Strength,
    }
  },
  methods: {
    newExerciseAction() {
      this.$emit('newPatientExercise', this.exerciseType)
      this.showNewExerciseDialog = false
    },
  },
}
